import styled from 'styled-components';
import { rem } from '@Components/styles';

export const SearchContainer = styled.div`
	position: absolute;
	top: ${rem(8)};
	left: ${rem(14)};
	z-index: 10;
	width: ${rem(312)};
	.MuiInputBase-root {
		background: #fff;
	}
`;
